var map = {
	"./DESA Travel.PNG": "./public/images/DESA Travel.PNG",
	"./Entitlement Travel for Home Leave, Education Grant and Family Visit.PNG": "./public/images/Entitlement Travel for Home Leave, Education Grant and Family Visit.PNG",
	"./Error Itinerary dashboard.PNG": "./public/images/Error Itinerary dashboard.PNG",
	"./General Travel Statistics - Prototype.PNG": "./public/images/General Travel Statistics - Prototype.PNG",
	"./Missing Expense Report.PNG": "./public/images/Missing Expense Report.PNG",
	"./Programme of Action on Small Arms and Light Weapons.PNG": "./public/images/Programme of Action on Small Arms and Light Weapons.PNG",
	"./Standards of Accommodation by Commercial Air.PNG": "./public/images/Standards of Accommodation by Commercial Air.PNG",
	"./Travel Compliance.PNG": "./public/images/Travel Compliance.PNG",
	"./Travel GHG dashboard.PNG": "./public/images/Travel GHG dashboard.PNG",
	"./Travel Volume.PNG": "./public/images/Travel Volume.PNG",
	"./Trip Refund dashboard.PNG": "./public/images/Trip Refund dashboard.PNG",
	"./UN Register of Conventional Arms (UNROCA).PNG": "./public/images/UN Register of Conventional Arms (UNROCA).PNG",
	"./UN Report on Military Expenditures (MilEx Database) .PNG": "./public/images/UN Report on Military Expenditures (MilEx Database) .PNG",
	"./UN Travel CO2 dashboard.PNG": "./public/images/UN Travel CO2 dashboard.PNG",
	"./WORLD DEVELOPMENT INDICATORS COPY1.PNG": "./public/images/WORLD DEVELOPMENT INDICATORS COPY1.PNG",
	"./WORLD DEVELOPMENT INDICATORS-LAPTOP-D43PV7H5.PNG": "./public/images/WORLD DEVELOPMENT INDICATORS-LAPTOP-D43PV7H5.PNG",
	"./WORLD DEVELOPMENT INDICATORS.PNG": "./public/images/WORLD DEVELOPMENT INDICATORS.PNG"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./public/images sync recursive ^\\.\\/.*\\.PNG$";